import queryString from 'query-string';
import { isNil, pickBy } from 'lodash';
import { serializeCampaignAssignments } from 'utils/campaignAssignmentsUrl';
import sortParam from './sortParam';

export default ({ page, perPage, sortBy, sortOrder, ...params }) =>
  queryString.stringify(
    pickBy(
      {
        ...params,
        page,
        page_size: perPage,
        ordering: sortParam({ sortBy, sortOrder }),
        campaign_assignments: Array.isArray(params?.campaign_assignments)
          ? serializeCampaignAssignments(params?.campaign_assignments)
          : params?.campaign_assignments,
        address_residential: Array.isArray(params?.address_residential)
          ? params?.address_residential.join(',')
          : params?.address_residential,
      },
      // Unset params (undefined or null) are left out: a null would go out as a bare `&key`, which the
      // API reads as "present" (a choice filter answers 400, a flag like only_deleted switches on).
      (item) => !isNil(item),
    ),
  );
